(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["teenutz-product"]) return;
  try {
    
document.addEventListener('change', function(event) {
  if (!event.target.matches('[data-teenutz-product] input[name="quantity"]')) return;
  const form = event.target.closest('form');
  const button = form.querySelector('button[name="add"]');
  button.disabled = event.target.dataset.purchasable !== 'true';
});

  } catch(e) { console.error(e); }
})();
})();
